export default [
  {
    header: "دسترسی ها",
  },
  // {
  //   title: 'Email',
  //   route: 'apps-email',
  //   icon: 'MailIcon',
  // },
  // {
  //   title: "چت",
  //   route: "apps-chats",
  //   icon: "MessageSquareIcon",
  //   resource: "Support",
  //   action: "Support",
  // },
  {
    title: "مدیریت پرسنل",
    route: "apps-admins",
    icon: "AwardIcon",
  },
  {
    title: "آگهی ها",
    route: "apps-ads-list",
    icon: "InboxIcon",
  },
  {
    title: "دسته بندی ها",
    icon: "ListIcon",
    children: [
      {
        title: "دسته بندی مجازی",
        route: "apps-categories-virtual-list",
      },
      {
        title: "دسته بندی محیطی",
        route: "apps-categories-physical-list",
      },
      {
        title: "دسته بندی اصناف",
        route: "apps-categories-guilds-list",
      },
    ],
  },
  {
    title: "پلن ها",
    icon: "GridIcon",
    children: [
      {
        title: "لیست پلن ها",
        route: "apps-plans-list",
      },
      {
        title: "ساخت پلن",
        route: "apps-plans-create",
      },
    ],
  },

  // {
  //   title: "استوری ها",
  //   icon: "InstagramIcon",
  //   children: [
  //     {
  //       title: "ساخت استوری",
  //       route: "apps-stories-add",
  //     },
  //   ],
  // },
  // {
  //   title: 'Todo',
  //   route: 'apps-todo',
  //   icon: 'CheckSquareIcon',
  // },
  // {
  //   title: 'Calendar',
  //   route: 'apps-calendar',
  //   icon: 'CalendarIcon',
  // },
  // {
  //   title: 'Invoice',
  //   icon: 'FileTextIcon',
  //   children: [
  //     {
  //       title: 'List',
  //       route: 'apps-invoice-list',
  //     },
  //     {
  //       title: 'Preview',
  //       route: { name: 'apps-invoice-preview', params: { id: 4987 } },
  //     },
  //     {
  //       title: 'Edit',
  //       route: { name: 'apps-invoice-edit', params: { id: 4987 } },
  //     },
  //     {
  //       title: 'Add',
  //       route: { name: 'apps-invoice-add' },
  //     },
  //   ],
  // },
  // {
  //   title: "محصولات",
  //   icon: "ShoppingCartIcon",
  //   children: [
  //     {
  //       title: "لیست محصولات",
  //       route: "apps-e-commerce-shop",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //     {
  //       title: "لیست دسته بندی های محصولات",
  //       route: "apps-e-commerce-categories",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //     {
  //       title: "افزودن محصول",
  //       route: "apps-e-commerce-add",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //     {
  //       title: "لیست نظرات محصولات",
  //       route: "apps-e-commerce-comments",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //   ],
  // },
  // {
  //   title: "دوره ها",
  //   icon: "BookIcon",
  //   children: [
  //     {
  //       title: "لیست دوره ها",
  //       route: "apps-e-commerce-courses",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //     {
  //       title: "افزودن دوره",
  //       route: "apps-e-commerce-add-course",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //     {
  //       title: "لیست دسته بندی های دوره ها",
  //       route: "apps-e-commerce-courses-categories",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //   ],
  // },
  {
    title: "بلاگ",
    icon: "BookOpenIcon",
    // resource: 'Blogger',
    // action: 'Blogger',
    children: [
      {
        title: "لیست بلاگ ها",
        route: "pages-blog-list",
        resource: "Blogger",
        action: "Blogger",
      },
      {
        title: "افزودن بلاگ",
        route: "pages-blog-create",
        resource: "Blogger",
        action: "Blogger",
      },
      {
        title: "دسته بندی های بلاگ",
        route: "pages-blog-categories-list",
        resource: "Blogger",
        action: "Blogger",
      },
      {
        title: "لیست نظرات بلاگ",
        route: "pages-blog-comments",
        resource: "Blogger",
        action: "Blogger",
      },
    ],
  },
  {
    title: "رسانه ها",
    icon: "ImageIcon",
    children: [
      {
        title: "کتابخانه",
        route: "pages-library-list",
      },
      // {
      //   title: "افزودن",
      //   route: "pages-library-add",
      // },
    ],
  },
  // {
  //   title: "کاربران",
  //   icon: "UserIcon",
  //   children: [
  //     {
  //       title: "لیست کاربران",
  //       route: "apps-users-list",
  //     },
  //   ],
  // },
  // {
  //   title: "کوپن ها",
  //   icon: "ShoppingBagIcon",
  //   children: [
  //     {
  //       title: "لیست کوپن ها",
  //       route: "apps-coupons-list",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //     {
  //       title: "ساخت کوپن",
  //       route: "apps-coupon-add",
  //       resource: "ProductManager",
  //       action: "ProductManager",
  //     },
  //   ],
  // },
  {
    title: "مالی",
    icon: "DollarSignIcon",
    children: [
      {
        title: "پرداخت ها",
        route: "apps-financial-payments-list",
        resource: "Accountent",
        action: "Accountent",
      },
    ],
  },

  {
    title: "سوالات متداول",
    icon: "TrelloIcon",
    children: [
      {
        title: "دسته بندی ها",
        route: "apps-faq-category",
      },
      {
        title: "ساخت سوال جدید",
        route: "apps-faq-create",
      },
      {
        title: "لیست سوال ها",
        route: "apps-faq-list",
      },
    ],
  },
  {
    title: "تیکت ها",
    route: "apps-tickets-list",
    icon: "MessageCircleIcon",
  },
  {
    title: "گزارش های چت",
    icon: "AlertTriangleIcon",
    route: "apps-reports-reports-list",
  },
  // {
  //   title: "سفارشات",
  //   icon: "TrelloIcon",
  //   children: [
  //     {
  //       title: "لیست سفارشات",
  //       route: "apps-orders-list",
  //       resource: "Accountent",
  //       action: "Accountent",
  //     },
  //   ],
  // },
  // {
  //   title: "دانشجویان",
  //   route: "apps-e-commerce-students",
  //   icon: "BookIcon",
  // },
];
